import { SvgConsumer } from '@components/icons/svgConsumer';
import { AlertBannerProps } from './types';
import { cn } from '@utils/cn';
import { variant } from './constants';

export const AlertBanner = ({ type, children }: AlertBannerProps) => (
  <div className={cn('flex items-center gap-3 px-4 py-2.5 text-sm font-medium', variant[type])}>
    <SvgConsumer className="shrink-0 text-xl" id={type} />
    {children}
  </div>
);
